import React from "react";
import { steps } from "../../data/services";
export function ProcessSection() {
  return <section aria-labelledby="process-title" className="px-5 py-24 lg:px-8 lg:py-32" data-id="element-115" data-mp="gtfy5wurrs8x">
      <div className="mx-auto max-w-[1360px]" data-id="element-116" data-mp="bul4fzv9kja1">
        <h2 id="process-title" className="max-w-2xl text-4xl font-bold leading-tight tracking-tight text-ink sm:text-5xl" data-id="element-117" data-mp="bta0o01tjbix">
          Comment se déroule votre chantier
        </h2>

        <ol className="mt-16 grid gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-8" data-id="element-118" data-mp="2v84bxt1571z">
          {steps.map((step, i) => <li key={step.title} className="relative flex flex-col" data-id="element-119" data-mp="3u79juyps5x5w" data-mpi={i}>
              <div className="flex items-center gap-4" data-id="element-120" data-mp="3p8zoan058ujr">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-accent text-base font-bold text-white" data-id="element-121" data-mp="3p7er0pmg2xi7">
                  {i + 1}
                </span>
                {i < steps.length - 1 && <span className="hidden h-px flex-1 bg-line lg:block" aria-hidden="true" data-id="element-122" data-mp="3ba017jsa4npp" />}
              </div>
              <h3 className="mt-6 text-xl font-bold tracking-tight text-ink" data-id="element-123" data-mp="3ocne7gt04r33">{step.title}</h3>
              <p className="mt-2 leading-relaxed text-muted" data-id="element-124" data-mp="3t3lyerh429bm">{step.text}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}